import React, { useEffect, useState } from 'react'
import { Section, SectionHeader, SectionTitle } from 'pixel-base'
import styled from 'styled-components'

import Address from './components/Address'

const Addresses = (props) => {
  const { countries, customer } = props

  const handleDeleteAddress = (address_id) => {
    const newAddresses = addresses.filter(
      (address: any) => address.address_id !== address_id,
    )
    setAddresses(newAddresses)
    props.handleUpdate(newAddresses)
  }

  const [addresses, setAddresses] = useState([
    {
      billingAddress: undefined,
    },
    { shippingAddress: undefined },
  ])

  useEffect(() => {
    if (customer && customer.addresses) {
      const shippingAddress = customer.addresses[0]
      const billingAddress = customer.addresses[1]

      setAddresses([
        {
          billingAddress: billingAddress || undefined,
        },
        {
          shippingAddress: shippingAddress || undefined,
        },
      ])
    }
  }, [customer])

  return (
    <>
      <AddressContainer>
        <Section>
          <SectionHeader>
            <SectionTitle>Addresses</SectionTitle>
          </SectionHeader>
          <AddressesContainer>
            {addresses.length > 0
              ? addresses.map((address: any, index: number) => {
                  const addressType =
                    Object.keys(address)[0] === 'billingAddress'
                      ? 'billing'
                      : 'shipping'
                  return (
                    <React.Fragment key={address.address_id}>
                      <Address
                        setAddresses={setAddresses}
                        key={index}
                        address={address}
                        customer_id={customer.customer_id}
                        addressType={addressType}
                        onDelete={(id) => {
                          handleDeleteAddress(id)
                        }}
                        countries={countries}
                      />
                    </React.Fragment>
                  )
                })
              : ''}
          </AddressesContainer>
        </Section>
      </AddressContainer>
    </>
  )
}

const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`

const AddressesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
`
export default Addresses
